module.exports = __webpack_public_path__ + "static/img/carbis.8b405b50.png";